/** Build Rhythm & Outcomes view models from API-backed Redux state. */

import {
  CADENCE_ORDER,
  CadenceKey,
  resolveCadenceLabel,
} from "./guidanceCadence";
import { GUIDANCE_ROLES } from "./guidanceRole";
import type {
  GuidancePlaybookContentDto,
  GuidanceRhythmCadenceDto,
  GuidanceRhythmProfileDto,
} from "../../Store/Reducers/GuidanceSlice";

/** Playbook Hub role display name from API rhythm profile role_label. */
export const resolveGuidanceRoleLabel = (
  role: string,
  profiles: GuidanceRhythmProfileDto[] = []
): string => {
  const label = profiles.find(p => p.role === role)?.role_label?.trim();
  if (label) return label;
  return GUIDANCE_ROLES.find(r => r.key === role)?.label ?? role;
};

export interface RhythmCadenceView {
  label: string;
  time: string;
  key: string;
  bullets: string[];
}

export interface RhythmRoleView {
  personaLabel: string;
  personaTagline: string;
  closingHeadline: string;
  closingBullets: string[];
  cadences: RhythmCadenceView[];
}

export const buildRhythmRoleView = (
  role: string,
  profiles: GuidanceRhythmProfileDto[],
  cadences: GuidanceRhythmCadenceDto[],
  playbooks: GuidancePlaybookContentDto[]
): RhythmRoleView => {
  const profile = profiles.find(p => p.role === role);
  const cadenceViews: RhythmCadenceView[] = CADENCE_ORDER.map(
    (key: CadenceKey) => {
      const row = cadences.find(c => c.role === role && c.cadence === key);
      const playbook = playbooks.find(
        p => p.role === role && p.cadence === key
      );
      return {
        key,
        label: resolveCadenceLabel(playbook?.cadence_tag, key),
        time: row?.time || "",
        bullets: row?.bullets?.length ? row.bullets : [],
      };
    }
  );

  return {
    personaLabel: resolveGuidanceRoleLabel(role, profiles),
    personaTagline: profile?.role_tagline || "",
    closingHeadline: profile?.closing_headline || "",
    closingBullets: profile?.closing_bullets?.length
      ? profile.closing_bullets
      : [],
    cadences: cadenceViews,
  };
};
